import PropTypes from 'prop-types';
import { Modal } from 'components';
import './ConfirmationModal.scss';

const ConfirmationModal = ({ visible, onClose, handleSaveParameter }) => {
  const handleClose = () => {
    onClose?.();
  };
  const handleOK = () => {
    onClose?.();
    handleSaveParameter();
  };

  return (
    <Modal
      title=""
      visible={visible}
      width="35em" // Se establece el tamaño asi por que antd sobreescribe el tamaño que se le pasa por clase
      onCancel={handleClose}
      onOk={handleOK}
      okText="Aceptar"
      cancelButtonProps={{
        style: { borderColor: '#da1188', color: '#da1188' }
      }}
      okButtonProps={{
        style: { borderColor: '#da1188' }
      }}>
      <div className="confirmation-parameters-modal">
        <span className="confirmation-parameters-modal-title">
          No se recuperará la versión anterior de la plantilla.
        </span>
        <span />
        <span className="confirmation-parameters-modal-descripcion">
          ¿Estás seguro de guardar los cambios de la plantilla?
        </span>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSaveParameter: PropTypes.func.isRequired
};

export default ConfirmationModal;
